import React from 'react';
import { ArrowBackIosRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';

var BackArrow = function BackArrow(_ref) {
  var handleBack = _ref.handleBack;
  return React.createElement(IconButton, {
    onClick: handleBack,
    disableRipple: true,
    sx: {
      padding: '0px',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  }, React.createElement(ArrowBackIosRounded, {
    fontSize: "large",
    sx: {
      color: 'secondary.main'
    }
  }));
};

export default BackArrow;